<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Stakeholder" >
              <input class="form-control" readonly :value="engagement.stakeholder.name">
            </form-group>

            <form-group label="Mode" :required="true">
              <b-form-select
                @blur="$v.engagement.mode.$touch"
                :class="{ 'is-invalid': $v.engagement.mode.$error }"
                v-model="engagement.mode"
                :options="modes"
              />
              <div class="invalid-feedback" v-if="!$v.engagement.mode.required">
                Please select mode
              </div>
            </form-group>

            <form-group label="Outcome">
              <b-form-select v-model="engagement.outcome" :options="outcomes" />
            </form-group>

            <form-group label="Engagement Date" :required="true">
              <b-form-datepicker
                id="example-datepicker"
                v-model="engagement.date"
                class="mb-2"
              ></b-form-datepicker>

              <div class="invalid-feedback" v-if="!$v.engagement.date.required">
                Please select date
              </div>
            </form-group>

            <form-group label="Engagement Time" :required="true">
              <b-form-timepicker
                v-model="engagement.time"
                locale="en"
              ></b-form-timepicker>

              <div class="invalid-feedback" v-if="!$v.engagement.time.required">
                Please select time
              </div>
            </form-group>

            <form-group label="Note">
              <textarea-autosize
                class="form-control"
                v-model="engagement.note"
              />
            </form-group>

            <div
              class="border-top my-3"
              v-if="userHasPerms(['Manage stakeholders'])"
            >
              <h4 class="py-3">Stakeholder Details</h4>

              <form-group label="Current Tier" :required="true">
                <b-form-select
          
                  v-model="engagement.stakeholder.current_tier"
                  :options="tiers"
                />
              
              </form-group>
              <form-group label="Desired Tier" :required="true">
                <b-form-select
              
                  v-model="engagement.stakeholder.desired_tier"
                  :options="tiers"
                />
           
              </form-group>

              <form-group label="Note">
                <textarea-autosize
                  class="form-control"
                  v-model="engagement.stakeholder.note"
                />
              </form-group>
            </div>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import engagementRepo from "@/api/repos/engagementRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    engagement: {
      mode: {
        required,
      },
      date: {
        required,
      },
      time: {
        required,
      },
      stakeholder_id: {
        required,
      },
     
    },
  },

  mounted() {
    this.getData();
    this.getEngagement();
  },

  props: ["id"],

  data() {
    return {
      engagement: {
        stakeholder:{}
      },
      modes: [],
      tiers: [],
      outcomes: [],
      loading: false,
      errors: null,
      submitStatus: null,
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await engagementRepo.createGetData();
        this.modes = data.modes;
        this.outcomes = data.outcomes;
        this.tiers = data.tiers;
      } catch (error) {
        console.log(error);
      }
    },

    async getEngagement() {
      try {
        this.loading = true;
        let { data } = await engagementRepo.get(this.id);

        this.engagement = data.engagement;

        this.engagement.date = this.moment(
          new Date(this.engagement.engagement_date)
        ).format("YYYY-MM-DD");

        this.engagement.time = this.moment(
          new Date(this.engagement.engagement_date)
        ).format("HH:mm");
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          this.engagement.engagement_date =
            this.engagement.date + " " + this.engagement.time;
          await engagementRepo.update(this.id, this.engagement);
          this.$emit("engagementUpdated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
